// extracted by mini-css-extract-plugin
module.exports = {"container":"TagsList_container__lPFhv"};